import React, { useContext } from "react";
import { GlobalContext } from "../../../App";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import {handleSave} from "../../../Utils/db/chatHistory/saveFullChat.ts";

interface AskToSaveProps {}

const AskToSave: React.FC<AskToSaveProps> = ({ }) => {
    const { messagesSequenceRef, resetStateHelper } = useContext(GlobalContext);
    const userObj = useAppStore((state: any) => state.userObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const updateChatHistory = useAppStore((state: any) => state.updateChatHistory);

    const handleClose = () => {
        resetStateHelper();
        setDynamicStateObj({visiblePopup: null});
    };

    const handleSaveClick = () => {
        handleSave(userObj.user, messagesSequenceRef, updateChatHistory, setDynamicStateObj).then(() => resetStateHelper())
    }

    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl w-[98%] sm:w-11/12 max-w-md overflow-hidden border border-neutral-700/50">
                <div className="p-6">
                    <h2 className="text-2xl font-bold mb-4 dark:text-white text-center">Save Chat</h2>
                    <p className="text-center mb-6 dark:text-neutral-200">Do you want to save the current chat?</p>
                    <div className="flex justify-center space-x-4">
                        <button
                            onClick={handleSaveClick}
                            className="bg-green-600 px-6 py-2 rounded-full hover:bg-green-700 transition-colors duration-200 text-white"
                        >
                            Yes
                        </button>
                        <button
                            onClick={handleClose}
                            className="bg-red-600 px-6 py-2 rounded-full hover:bg-red-700 transition-colors duration-200 text-white"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AskToSave;